import React from 'react';
import { IconButton, Spinner } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import EditIcon from '../../icons/EditIcon/EditIcon';
import { useTokens } from '../../../context/TokenProvider';
import SearchIcon from '../../icons/SearchIcon/SeachIcon';
const AddressSearchIcon = ({ isLoading, state, onEdit, onSearch, ...rest }) => {
    const tokens = useTokens();
    if (isLoading) {
        return React.createElement(Spinner, { "data-testid": "address_search_icon_spinner", size: "sm" });
    }
    switch (state) {
        case 'address':
            return (React.createElement(IconButton, { ...rest, "data-testid": "address_search_icon_edit", variant: "ghost", "aria-label": localise('EDIT_ADDRESS'), icon: React.createElement(EditIcon, { width: "24", height: "24", fill: tokens.IconMedium600 }), onClick: onEdit }));
        case 'postcode':
            return (React.createElement(IconButton, { ...rest, "data-testid": "address_search_icon_search", variant: "ghost", "aria-label": localise('SEARCH_POSTCODE'), icon: React.createElement(SearchIcon, { fill: tokens.IconMedium600 }), onClick: onSearch }));
        default:
            return null;
    }
};
export default AddressSearchIcon;
